import { render, staticRenderFns } from "./ArticleListContent.vue?vue&type=template&id=264f18a2&scoped=true"
import script from "./ArticleListContent.vue?vue&type=script&lang=js"
export * from "./ArticleListContent.vue?vue&type=script&lang=js"
import style0 from "./ArticleListContent.vue?vue&type=style&index=0&id=264f18a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f18a2",
  null
  
)

export default component.exports